export default __webpack_public_path__ + "static/award-86c5f572b1fa2dcdc4ca0ad8b9ece5c6.png";